import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { rutaRequiereSesion, verificarSesionActiva } from '../helpers/verificarSesionActiva';

// Verifica la sesión activa al cargar la página, al cambiar de ruta y al
// volver a la pestaña. Si la sesión ya no es válida, dispara 'sesion-expirada'
// que limpia localStorage y redirige a la pantalla de inicio.
// Las rutas de kiosko / pantallas de sala (sin sesión) se omiten.
export const GuardiaSesion = () => {
    const location = useLocation();
    const pathRef = useRef(location.pathname);

    useEffect(() => {
        pathRef.current = location.pathname;
    }, [location.pathname]);

    useEffect(() => {
        let activo = true;

        const revisar = async () => {
            if (!rutaRequiereSesion(pathRef.current)) return;

            const sesionActiva = await verificarSesionActiva();
            if (!activo) return;
            if (!sesionActiva && rutaRequiereSesion(pathRef.current)) {
                window.dispatchEvent(new CustomEvent('sesion-expirada'));
            }
        };

        const alEnfocar = () => revisar();
        const alVisibilidad = () => {
            if (document.visibilityState === 'visible') revisar();
        };

        revisar();
        window.addEventListener('focus', alEnfocar);
        document.addEventListener('visibilitychange', alVisibilidad);

        return () => {
            activo = false;
            window.removeEventListener('focus', alEnfocar);
            document.removeEventListener('visibilitychange', alVisibilidad);
        };
    }, []);

    return null;
};